export const AI_PROVIDER_IDS = ['gemini', 'xai'] as const

export type AIProviderId = typeof AI_PROVIDER_IDS[number]

export interface AIProviderOption {
  id: AIProviderId
  label: string
  apiKeyLabel: string
  apiKeyPlaceholder: string
  apiKeyUrl: string
}

export const DEFAULT_AI_PROVIDER = 'gemini' as const

export const AI_PROVIDER_OPTIONS: readonly AIProviderOption[] = [
  {
    id: 'gemini',
    label: 'Gemini',
    apiKeyLabel: 'Gemini APIキー',
    apiKeyPlaceholder: 'AIza...',
    apiKeyUrl: 'https://aistudio.google.com/app/apikey',
  },
  {
    id: 'xai',
    label: 'Grok（xAI）',
    apiKeyLabel: 'xAI APIキー',
    apiKeyPlaceholder: 'xai-...',
    apiKeyUrl: 'https://console.x.ai/',
  },
] as const

export function isAIProviderId(value: unknown): value is AIProviderId {
  return typeof value === 'string' &&
    AI_PROVIDER_IDS.includes(value as AIProviderId)
}

export function getAIProviderOption(id: AIProviderId): AIProviderOption {
  return AI_PROVIDER_OPTIONS.find(option => option.id === id) as AIProviderOption
}
